import e from "react";

function t(e) {
  return (t = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}

function n(e, t) {
  return (n = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}

function r(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

var o = function (o) {
  function i(e) {
    var n, o;
    return function (e, t) {
      if (!(e instanceof i)) throw new TypeError("Cannot call a class as a function");
    }(this), (n = !(o = t(i).call(this, e)) || "object" != typeof o && "function" != typeof o ? r(this) : o).onKeyPress = n.onKeyPress.bind(r(n)), n;
  }

  var a;
  return function (e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && n(e, t);
  }(i, e.Component), (a = [{
    key: "onKeyPress",
    value: function value(e) {
      var t = this.props,
          n = t.onClick,
          r = t.onKeyPress;

      switch (e.key) {
        case " ":
        case "Spacebar":
          e.preventDefault(), n && r ? r(e) : r ? r(e) : n && n(e);
          break;

        case "Enter":
          if (r && (r(e), e.isDefaultPrevented())) return;
          n && n(e);
      }
    }
  }, {
    key: "render",
    value: function value() {
      var t = this.props,
          n = t.is,
          r = void 0 === n ? "span" : n,
          o = t.innerRef,
          i = t.onClick,
          a = t.disabled,
          c = t.tabIndex,
          s = void 0 === c ? 0 : c,
          u = function (e, t) {
        if (null == e) return {};

        var n,
            r,
            o = function (e, t) {
          if (null == e) return {};
          var n,
              r,
              o = {},
              i = Object.keys(e);

          for (r = 0; r < i.length; r++) {
            t.indexOf(n = i[r]) >= 0 || (o[n] = e[n]);
          }

          return o;
        }(e, t);

        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(e);

          for (r = 0; r < i.length; r++) {
            t.indexOf(n = i[r]) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
          }
        }

        return o;
      }(t, ["is", "innerRef", "onClick", "disabled", "tabIndex", "onKeyPress"]);

      return e.createElement(r, Object.assign({
        tabIndex: a ? void 0 : s,
        role: "button",
        onKeyPress: a ? void 0 : this.onKeyPress,
        onClick: a ? void 0 : i,
        "aria-disabled": a ? "true" : void 0,
        ref: o
      }, u));
    }
  }]) && function (e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }(i.prototype, a), i;
}();

function i(t, n) {
  return e.createElement(o, Object.assign({
    innerRef: n
  }, t));
}

i.displayName = "ClickableBox";
export default e.forwardRef(i);